import SpineSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/spine-symbol-behaviour";
import Contract from "slotworks/utils/contract";

export default class LandSpineSymbolBehaviour extends SpineSymbolBehaviour {

    public land(...args: any[]): Contract<void> {
        return this.animate("land", true, false);
    }

    public highlight(): Contract<void> {
        return Contract.empty();
    }

    public win(): Contract<void> {
        return Contract.empty();
    }

    public cycle(): Contract<void> {
        return Contract.empty();
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/symbol/behaviours/land-spine-symbol-behaviour.ts